import Skiplinks from './skiplinks';

export default (di) => {
	di
		.setType({type: Skiplinks, name: 'SkipLinks', parent: 'PageComponent'})
	;
};
